import { memo, useState, useRef } from 'react'
import { useAccounIsMumber } from '@/hooks'
import FistStep from './FistStep'
import TwoStep from './TwoStep'
import { SenderTokenSwapper } from './style'

function App() {
  useAccounIsMumber()
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isHoldToken, setIsHoldToken] = useState(false)

  const isHoldTokenChange = (e: boolean) => {
    setIsHoldToken(e)
  }

  const addIndexHandler = () => {
    console.log(isHoldToken)
    setCurrentIndex(currentIndex + 1)
  }

  const decCurrentIndex = () => {
    setCurrentIndex(currentIndex - 1)
  }

  return (
    <SenderTokenSwapper>
      {/* <Header index={currentIndex} /> */}
      {currentIndex === 0 && <FistStep nextStep={addIndexHandler} isHoldToken={isHoldToken} isHoldTokenChange={isHoldTokenChange} />}
      {currentIndex === 1 && <TwoStep upStep={decCurrentIndex} senderBase={isHoldToken ? 30 : 200} />}
    </SenderTokenSwapper>
  )
}

export default memo(App)
